/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import upload from '@iconify/icons-feather/upload';

import {useTranslation} from 'react-i18next';

import BolmateSetupCard from './bolmateSetupCard';

interface Props {
    completed?: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
    className?: string;
}

export default function BolmateInvoiceUploadCard(props: Props) {
    const {completed, onClick, onCheckClick, className} = props;
    const {t} = useTranslation();

    return (
        <BolmateSetupCard
            className={className}
            title={t('controls.setupCard.invoiceUpload.title', 'Auto-upload')}
            subtitle={t('controls.setupCard.invoiceUpload.subtitle', 'Upload facturen naar Bol')}
            icon={upload}
            completed={completed}
            onClick={onClick}
            onCheckClick={onCheckClick}
        />
    );
}
